export function Panel({ title, count, children, testId }) {
  return (
    <section
      data-testid={testId}
      className="bg-white border border-[#E5E0D8] p-6 flex flex-col gap-3"
    >
      <header className="flex items-baseline justify-between">
        <h2 className="text-sm font-extrabold uppercase tracking-[0.18em] text-[#0B3D5C]">
          {title}
        </h2>
        {count !== undefined && (
          <span className="text-xs font-bold text-[#E07B3A]">{count}</span>
        )}
      </header>
      <div className="flex flex-col divide-y divide-[#F0EBE3]">{children}</div>
    </section>
  );
}

export function Row({ primary, secondary, meta }) {
  return (
    <div className="py-2.5">
      <p className="text-sm font-semibold text-[#1A1A1A] leading-snug">{primary}</p>
      {secondary && (
        <p className="text-xs text-[#4A4A4A] mt-0.5 leading-snug line-clamp-2">{secondary}</p>
      )}
      {meta && <p className="text-[11px] text-[#8A8378] mt-1">{meta}</p>}
    </div>
  );
}

export const EMPTY = <p className="py-3 text-sm text-[#8A8378]">Nothing yet.</p>;
